export default {
	'#general': 'General',
	'#social': 'Social profiles',
	// '#security': 'Security'
}